import { memo } from "react";
import { cn } from "utils";

interface SignalLevelIndicatorProps {
  labelList: {
    key?: string;
    label: React.ReactNode | string; // 如需传入React.ReactNode 需要定义key
    className?: string;
  }[];
  className?: string;
}

const SignalLabelList = ({
  labelList,
  className,
}: SignalLevelIndicatorProps) => {
  return (
    <div className={cn("w-full flex flex-row gap-1", className)}>
      {labelList.map((labelItem) => (
        <div
          key={labelItem.key || (labelItem.label as string)}
          className={cn(
            "body_bold_s text-content_primary bg-background_white_overlay20 rounded py-[2px] px-[6px]",
            labelItem.className,
          )}
        >
          {labelItem.label}
        </div>
      ))}
    </div>
  );
};

export default memo(SignalLabelList);
